<div class="row">
  <div
    *ngFor="let parametro of schema.parametros"
    [class.col-6]="schema.parametros.length == 2"
    [class.col]="schema.parametros.length != 2"
  >
    <app-parametro-funcao-percentual
      *ngIf="parametro.tipo == 'PERCENTUAL'"
      [schema]="parametro"
      [schemaParent]="schema"
      [formGroup]="formGroup"
      [readonly]="readonly"
      [value]="value? value[parametro.variavel] : null"
    ></app-parametro-funcao-percentual>
    <app-parametro-funcao-valor-financeiro
      *ngIf="parametro.tipo == 'VALOR_FINANCEIRO'"
      [schema]="parametro"
      [schemaParent]="schema"
      [formGroup]="formGroup"
      [readonly]="readonly"
      [value]="value? value[parametro.variavel] : null"
    ></app-parametro-funcao-valor-financeiro>
    <app-parametro-funcao-valor-inteiro
        *ngIf="parametro.tipo == 'VALOR_INTEIRO'"
        [schema]="parametro"
        [schemaParent]="schema"
        [formGroup]="formGroup"
        [readonly]="readonly"
        [value]="value? value[parametro.variavel] : null"
    ></app-parametro-funcao-valor-inteiro>
    <app-parametro-funcao-valor-checkbox
        *ngIf="parametro.tipo == 'CHECKBOX'"
        [schema]="parametro"
        [schemaParent]="schema"
        [formGroup]="formGroup"
        [readonly]="readonly"
        [parametrosRegra]="parametrosRegra"
    ></app-parametro-funcao-valor-checkbox>
    <app-parametro-funcao-valor-boolean
      *ngIf="parametro.tipo == 'BOOLEAN'"
      [schema]="parametro"
      [schemaParent]="schema"
      [formGroup]="formGroup"
      [readonly]="readonly"
      [value]="value? value[parametro.variavel] : null"
    ></app-parametro-funcao-valor-boolean>
  </div>
</div>
